import '../../scripts/domPolyfills/classList';

export function smartHomeInit(snippetId) {
  const snippetSelector = `[data-smart-home='${snippetId}']`;

  let activeTab = 'tab_control';

  const controlsTabs = document.querySelectorAll(
    `${snippetSelector} .smart-home__tab`
  );

  const tabArrowPrevious = document.querySelector(
    `${snippetSelector} [data-prev-tab]`
  );
  const tabArrowNext = document.querySelector(
    `${snippetSelector} [data-next-tab]`
  );

  controlsTabs.forEach((controlEl) => {
    controlEl.onclick = ({ target }) => {
      const currentTab = target.dataset ? target.dataset.tab : null;

      if (!currentTab) {
        console.error(
          'Missed data-tab attribute into Element .smart-home__tab'
        );

        return;
      }

      updateActiveTab(activeTab, currentTab);
    };
  });

  tabArrowPrevious.onclick = ({ target }) => {
    if (target.dataset && target.dataset.prevTab) {
      updateActiveTab(activeTab, target.dataset.prevTab);
    }
  };

  tabArrowNext.onclick = ({ target }) => {
    if (target.dataset && target.dataset.nextTab) {
      updateActiveTab(activeTab, target.dataset.nextTab);
    }
  };

  updateActiveTab(null, activeTab);

  function updateActiveTab(oldTab, newTab) {
    const controlTabsClassActive = 'smart-home__tab--active';

    const imageTabsClass = 'smart-home__example-tab';
    const imageTabsClassActive = 'smart-home__example-tab--active';
    const imageTabs = document.querySelectorAll(
      `${snippetSelector} .${imageTabsClass}`
    );

    const textTabsClass = 'smart-home__text';
    const textTabsClassActive = 'smart-home__text--active';
    const textTabs = document.querySelectorAll(
      `${snippetSelector} .${textTabsClass}`
    );

    if (oldTab !== newTab) {
      changeActiveClass(
        getElementByTab(oldTab, controlsTabs),
        controlTabsClassActive,
        false
      );
      changeActiveClass(
        getElementByTab(newTab, controlsTabs),
        controlTabsClassActive,
        true
      );

      changeActiveClass(
        getElementByTab(oldTab, imageTabs),
        imageTabsClassActive,
        false
      );
      changeActiveClass(
        getElementByTab(newTab, imageTabs),
        imageTabsClassActive,
        true
      );

      changeActiveClass(
        getElementByTab(oldTab, textTabs),
        textTabsClassActive,
        false
      );
      changeActiveClass(
        getElementByTab(newTab, textTabs),
        textTabsClassActive,
        true
      );

      updateArrows(newTab);
      updateActiveExample(newTab);
      updateCaretPosition(newTab);

      document.querySelector(snippetSelector).dataset.tabActive = newTab;

      activeTab = newTab;
    }
  }

  window.onresize = () => updateCaretPosition(activeTab);

  function getElementByTab(tabName, elementList) {
    return Array.from(elementList).find(
      (element) => tabName === element.dataset.tab
    );
  }

  function updateArrows(activeTabData) {
    const activeIndex = Array.from(controlsTabs).findIndex(
      (el) => activeTabData === el.dataset.tab
    );
    const maxIndex = controlsTabs.length - 1;
    const minIndex = 0;

    const newNextTabIndex =
      activeIndex >= maxIndex ? minIndex : activeIndex + 1;
    const newPrevTabIndex =
      activeIndex <= minIndex ? maxIndex : activeIndex - 1;

    const prevTab = controlsTabs[newPrevTabIndex]
      ? controlsTabs[newPrevTabIndex].dataset.tab
      : null;

    if (prevTab) {
      tabArrowPrevious.dataset.prevTab = prevTab;
    }

    const nextTab = controlsTabs[newPrevTabIndex]
      ? controlsTabs[newNextTabIndex].dataset.tab
      : null;

    if (nextTab) {
      tabArrowNext.dataset.nextTab = nextTab;
    }
  }

  function changeActiveClass(element, activeClass, isAdd = true) {
    if (element && element.classList) {
      if (isAdd) {
        element.classList.add(activeClass);
      } else {
        element.classList.remove(activeClass);
      }
    }
  }

  function updateActiveExample(activeTabVal = null) {
    const activeClassExample = 'smart-home__example--active';
    const customTabsExampleEls = document.querySelectorAll(
      `${snippetSelector} [data-tabs-custom]`
    );
    const defaultTabsExampleEl = document.querySelector(
      `${snippetSelector} [data-tabs-default]`
    );

    let isActiveCustomTab = false;

    customTabsExampleEls.forEach((tabExampleEl) => {
      const isActiveExample = (
        tabExampleEl.dataset ? tabExampleEl.dataset.tabsCustom : ''
      )
        .split(',')
        .includes(activeTabVal);

      changeActiveClass(tabExampleEl, activeClassExample, isActiveExample);

      if (isActiveExample) {
        isActiveCustomTab = true;
      }
    });

    changeActiveClass(
      defaultTabsExampleEl,
      activeClassExample,
      !isActiveCustomTab
    );
  }

  function updateCaretPosition(tab) {
    const caretEl = document.querySelector(
      `${snippetSelector} .smart-home__tabs-caret`
    );
    const activeTabItem = getElementByTab(tab, controlsTabs);

    if (caretEl) {
      caretEl.style.left = `${activeTabItem.offsetLeft}px`;
      caretEl.style.width = `${activeTabItem.offsetWidth}px`;
    }
  }
}
